/* nm-results-slider: loop carousel (arrows, dots, swipe) for the home testimonials. */
(function () {
  if (window.__nmRs) return;
  window.__nmRs = true;
  function init(root) {
    if (root.__nmRs) return;
    root.__nmRs = true;
    var list = root.querySelector('[data-nm-rs-list]');
    var slides = root.querySelectorAll('[data-nm-rs-slide]');
    var dots = root.querySelectorAll('[data-nm-rs-dot]');
    var n = slides.length, i = 0;
    if (!list || n < 2) return;
    function go(k) {
      i = (k + n) % n;
      var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      list.style.transform = 'translateX(' + (-i * (slides[0].getBoundingClientRect().width + gap)) + 'px)';
      dots.forEach(function (d, j) { if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    var prev = root.querySelector('[data-nm-rs-prev]'), next = root.querySelector('[data-nm-rs-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-nm-rs-dot')); }); });
    var x0 = null;
    list.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    list.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
    });
    list.addEventListener('pointercancel', function () { x0 = null; });
    window.addEventListener('resize', function () { list.style.transition = 'none'; go(i); list.offsetHeight; list.style.transition = ''; });
  }
  function all() { document.querySelectorAll('[data-nm-rs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
